// import { PixelCrop } from 'react-image-crop';

interface BlobResult {
  blob: Blob;
  blobUrl?: string;
  revokeUrl?: () => void;
}

const getBlobFromCanvas = (
  canvas: HTMLCanvasElement,
  file?: File,
  withUrl?: boolean,
): Promise<BlobResult> =>
  new Promise((resolve, reject) => {
    if (file) {
      canvas.toBlob((blob) => {
        if (blob) {
          // Assign properties from the original file to the new blob
          // Using 'as any' to add properties not normally on Blob
          (blob as any).name = file.name;
          (blob as any).lastModified = file.lastModified;

          let blobUrl: string | undefined;
          let revokeUrl: (() => void) | undefined; // Declare revokeUrl here

          if (withUrl) {
            blobUrl = URL.createObjectURL(blob);
            // Only assign revokeUrl if blobUrl is created
            revokeUrl = () => URL.revokeObjectURL(blobUrl!);
          }

          resolve({ blob, blobUrl, revokeUrl });
        } else {
          reject(new Error('Canvas is empty'));
        }
      }, file.type);
    }
  });

const TO_RADIANS = Math.PI / 180;

export async function canvasPreview(
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: { x: number; y: number; width: number; height: number },
  scale: number = 1,
  rotate: number = 0,
  file?: File,
  withUrl: boolean = false,
): Promise<BlobResult> {
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  // devicePixelRatio slightly increases sharpness on retina devices
  const pixelRatio = window.devicePixelRatio;

  // Adjust canvas size for high DPI screens
  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  const rotateRads = rotate * TO_RADIANS;
  const centerX = image.naturalWidth / 2;
  const centerY = image.naturalHeight / 2;

  ctx.save();

  // Translate to crop origin
  ctx.translate(-cropX, -cropY);
  // Move to center of image
  ctx.translate(centerX, centerY);
  // Rotate
  ctx.rotate(rotateRads);
  // Scale
  ctx.scale(scale, scale);
  // Move back to origin
  ctx.translate(-centerX, -centerY);

  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
  );

  ctx.restore();

  return await getBlobFromCanvas(canvas, file, withUrl);
}

// // import { PixelCrop } from 'react-image-crop';

// const getBlobFromCanvas = (canvas, file, withUrl) =>
//   new Promise((resolve, reject) => {
//     canvas.toBlob((blob) => {
//       if (blob) {
//         blob.name = file.name;
//         blob.lastModified = file.lastModified;

//         let blobUrl, revokeUrl;

//         if (withUrl) {
//           blobUrl = URL.createObjectURL(blob);
//           revokeUrl = () => URL.revokeObjectURL(blobUrl);
//         }

//         resolve({ blob, blobUrl, revokeUrl });
//       } else {
//         reject(new Error('Canvas is empty'));
//       }
//     }, file.type);
//   });
// const TO_RADIANS = Math.PI / 180;

// export async function canvasPreview(
//   image,
//   canvas,
//   crop,
//   scale = 1,
//   rotate = 0,
//   file,
//   withUrl = false
// ) {
//   const ctx = canvas.getContext('2d');

//   if (!ctx) {
//     throw new Error('No 2d context');
//   }

//   const scaleX = image.naturalWidth / image.width;
//   const scaleY = image.naturalHeight / image.height;
//   // devicePixelRatio slightly increases sharpness on retina devices
//   // at the expense of slightly slower render times and needing to
//   // size the image back down if you want to download/upload and be
//   // true to the images natural size.
//   const pixelRatio = window.devicePixelRatio;
//   // const pixelRatio = 1

//   canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
//   canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

//   ctx.scale(pixelRatio, pixelRatio);
//   ctx.imageSmoothingQuality = 'high';

//   const cropX = crop.x * scaleX;
//   const cropY = crop.y * scaleY;

//   const rotateRads = rotate * TO_RADIANS;
//   const centerX = image.naturalWidth / 2;
//   const centerY = image.naturalHeight / 2;

//   ctx.save();

//   // 5) Move the crop origin to the canvas origin (0,0)
//   ctx.translate(-cropX, -cropY);
//   // 4) Move the origin to the center of the original position
//   ctx.translate(centerX, centerY);
//   // 3) Rotate around the origin
//   ctx.rotate(rotateRads);
//   // 2) Scale the image
//   ctx.scale(scale, scale);
//   // 1) Move the center of the image to the origin (0,0)
//   ctx.translate(-centerX, -centerY);
//   ctx.drawImage(
//     image,
//     0,
//     0,
//     image.naturalWidth,
//     image.naturalHeight,
//     0,
//     0,
//     image.naturalWidth,
//     image.naturalHeight
//   );

//   ctx.restore();
//   return await getBlobFromCanvas(canvas, file, withUrl);
// }
